/* Companion to the media-loading-placeholder rules in base.css.
   Adds .media-loaded to every <img> once its file has actually painted,
   which clears --media-placeholder-bg so transparent images do not keep
   a grey box behind them. Failed loads keep the placeholder on purpose —
   a grey slot looks intentional, a broken-image icon does not.
   Watches the whole document, including nodes injected after load
   (cart drawer, predictive search results, slider clones). */
(function () {
  var SMALL_IMAGE_MAX_WIDTH = 200;

  /* Small decorative images (badges, droplets, bubbles) skip the skeleton
     entirely — a grey box behind tiny artwork reads as a glitch, not as
     loading feedback. Rendered width decides when the image is laid out;
     the width attribute covers images that are not yet rendered. */
  function isSmall(img) {
    var rect = img.getBoundingClientRect();
    if (rect.width > 0) return rect.width < SMALL_IMAGE_MAX_WIDTH;
    var attr = parseInt(img.getAttribute('width'), 10);
    return attr > 0 && attr < SMALL_IMAGE_MAX_WIDTH;
  }

  function markLoaded(img) {
    /* Re-check size at load: an image with no width attribute and no
       CSS-given width has zero layout width until its file arrives, so
       the scan can't classify it. Excluding it here (transition: none in
       base.css) snaps the grey away instead of fading it behind the
       artwork as it appears. */
    if (isSmall(img)) {
      img.setAttribute('data-no-placeholder', '');
      return;
    }
    img.classList.add('media-loaded');
  }

  function watch(img) {
    if (img.classList.contains('media-loaded')) return;
    if (img.hasAttribute('data-no-placeholder')) return;
    if (isSmall(img)) {
      img.setAttribute('data-no-placeholder', '');
      return;
    }
    if (img.complete) {
      if (img.naturalWidth > 0) markLoaded(img);
    } else {
      img.addEventListener(
        'load',
        function () {
          markLoaded(img);
        },
        { once: true }
      );
    }
  }

  function scan(root) {
    if (root.tagName === 'IMG') watch(root);
    if (root.querySelectorAll) root.querySelectorAll('img').forEach(watch);
  }

  scan(document.documentElement);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
